import React from 'react';
import './ContactUs.css';
import Navbar from './Navbar';

function ContactUs() {
  const locations = [
    { title: "Mourya", address: "23EE10020", phone: "9133546256", email: "grandhimourya@kgpian.iitkgp.ac.in" }
  ];

  const handlePhoneClick = (phone) => {
    window.location.href = `tel:${phone}`;
  };

  const handleEmailClick = (email) => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="contactus">
      <Navbar/>
      <div className="contact-header">
        <h1>Contact Us</h1>
      </div>
      <div className="address-boxes">
        {locations.map((location, index) => (
          <div key={index} className="address-box">
            <div className="doctor-symbol">👨‍⚕️</div>
            <h2>{location.title}</h2>
            <p>{location.address}</p>
            <p className="phone" onClick={() => handlePhoneClick(location.phone)}>
              Phone: {location.phone}
            </p>
            <p className="email" onClick={() => handleEmailClick(location.email)}>
              Email: {location.email}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContactUs;